const Heading = (props) => {
    return (<>
        {props?.type == "h1" && <h1>{props?.text}</h1>}
        {props?.type == "h2" && <h2>{props?.text}</h2>}
        {props?.type == "h3" && <h3>{props?.text}</h3>}
        {props?.type == "h4" && <h4>{props?.text}</h4>}
        {props?.type == "h5" && <h5>{props?.text}</h5>}
        {props?.type == "h6" && <h6>{props?.text}</h6>}
    </>
    )
}

export default Heading;